import { render, staticRenderFns } from "./IndexProdItem.vue?vue&type=template&id=cab082c8&scoped=true"
import script from "./IndexProdItem.vue?vue&type=script&lang=js"
export * from "./IndexProdItem.vue?vue&type=script&lang=js"
import style0 from "./IndexProdItem.vue?vue&type=style&index=0&id=cab082c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab082c8",
  null
  
)

export default component.exports